// TODO: simplify when module namespaced
export const PRODUCT_CHANGE_OF_ADDRESS_2ND_PHASE_PROCESS_CLEAR_STATE = "clearProductChangeOfAddress2ndPhaseProcessState";

// TODO: simplify when module namespaced
export const PRODUCT_CHANGE_OF_ADDRESS_2ND_PHASE_PROCESS_CLEAR_ACTION = "clearProductChangeOfAddress2ndPhaseProcessAction";

export const ProductChangeOfAddress2ndPhaseProcessStoreActions = {
	CLEAR: `${PRODUCT_CHANGE_OF_ADDRESS_2ND_PHASE_PROCESS_CLEAR_ACTION}`
} as const;
